import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { ApiService, Carrello, Indirizzo, ProdottoCarrello } from './api.service';
import { TokenizeResult } from '@angular/compiler/src/ml_parser/lexer';
import { HeaderService } from './header.service';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.sevice';

export class MetodoSpedizione {
  metodoSelezionato?;
  country?;
  cap?;
  installatore?;
  installazioneSelezionata?;
}

export class FormIndirizzo {
  idIndirizzo;
  nome;
  cognome;
  societa;
  telefono;
  via;
  citta;
  cap;
  nazione;
}


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    @Inject(PLATFORM_ID) platformId,
    private apiService: ApiService,
    private translate: TranslateService,
    private header: HeaderService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isBrowser: boolean;

  set(key, value) {
    if (this.isBrowser) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }

  get(key) {
    if (this.isBrowser) {
      return JSON.parse(sessionStorage.getItem(key));
    }
  }

  setLocal(key, value) {
    if (this.isBrowser) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  getLocal(key) {
    if (this.isBrowser) {
      return JSON.parse(localStorage.getItem(key));
    }
  }

  /* ---------- */

  getMappone(language) {
    if (this.isBrowser && this.get('superServizio_' + language)) {
      return of(this.get('superServizio_' + language));
    } else {
      return this.apiService.superServizio({ language });
    }
  }

  getMapponeInLingua() {
    const language = this.translate.currentLang;
    if (!language) { return null; }
    return this.getMappone(language);
  }

  getAbilitazioneCookie(cookie) {
    const permessi = this.getLocal('permessi');
    if (!permessi) { return false; }
    return permessi[cookie];
  }

  setAbilitazioneCookie(cookie, abilitato) {
    let permessi = this.getLocal('permessi');
    if (!permessi) { permessi = {}; }
    permessi[cookie] = abilitato;
    permessi.scadenza = new Date().setDate(new Date().getDate() + 30);
    this.setLocal('permessi', permessi);
  }

  getCookiesScaduti() {
    const permessi = this.getLocal('permessi');
    if (!permessi || !permessi.scadenza) { return true; }
    return new Date() > permessi.scadenza;
  }

  /* INDIRIZZI  */

  salvaIndirizzoUtente(indirizzo: Indirizzo): Observable<Indirizzo[]> {
    indirizzo['language'] = this.translate.currentLang.toUpperCase();
    return this.apiService.utenteRegistratoSaveIndirizzo(indirizzo).pipe(map(res => {
      if (res) {
        const user = this.getLocal('user-stem');
        user.indirizzi = res.filter(i => i.enabled);
        this.setLocal('user-stem', user);
      }
      return res.filter(i => i.enabled);
    }));
  }

  /* Spese spedizione */

  getSpeseSpedizione(): Observable<any> {
    if (this.isBrowser) {
      const cdLingua = this.translate.currentLang.toUpperCase();
      // const spese: Carrello = this.get('spese-spedizione');
      // if (spese) { return of(spese); }
      return this.apiService.getSpeseSpedizione({cdLingua}).pipe(map((res: any) => {
        this.set('spese-spedizione', res);
        return res;
      }));
    }
  }

}
